<template>

  <section class="rotated-slider">
    <div class="rotated-slider__container">
      <carousel
        class="rotated-slider__carousel rotated-slider__carousel--fog"
        :center="true"
        :loop="true"
        :nav="false"
        :dots="false"
        :autoplay="false"
        :items="5"
        @drag="addGrabClass"
        @dragged="removeGrabClass"
      >
        <div
          v-for="(profile, index) in profiles"
          :key="index"
          class="rotated-slider__element"
        >
          <div class="rotated-slider__img" :style="{ backgroundImage: `url( ${profile.home_avatar_url} )` }"></div>
          <a
            class="button button--primary"
            @mousedown.prevent.stop
            :href="zRoute('front.profile.show', profile.id)"
          >
            <i class="demo-icon icon-heart"></i>
          </a>
          <a
            class="button button--secoundary button--close"
            @mousedown.prevent.stop
            @click="$refs.next.click()"
          >
            <i class="demo-icon icon-close"></i>
          </a>
        </div>
        <template slot="prev"><span hidden ref="prev" class="prev">prev</span></template>
        <template slot="next"><span hidden ref="next" class="next">next</span></template>
      </carousel>
      <div class="bubbles bubbles--reverse">
        <div class="bubbles__bubble bubbles__bubble--small"></div>
        <div class="bubbles__bubble bubbles__bubble--medium"></div>
        <div class="bubbles__bubble bubbles__bubble--big"></div>
      </div>
      <div class="bubbles">
        <div class="bubbles__bubble bubbles__bubble--small"></div>
        <div class="bubbles__bubble bubbles__bubble--medium"></div>
        <div class="bubbles__bubble bubbles__bubble--big"></div>
      </div>
    </div>
  </section>

</template>

<script>

import carousel from 'vue-owl-carousel';

export default {
  name: 'RotatedSlider',
  components: { carousel },
  props: {
    profiles: {
      type: Array,
      required: true
    }
  },
  methods: {
    addGrabClass(e) {
      e.target.classList.add('owl-grab');
      document.querySelector('.rotated-slider__container').classList.add('owl-grab');
    },
    removeGrabClass() {
      document.querySelector('.rotated-slider__container').classList.remove('owl-grab');
    }
  }
};
</script>
